export class Booking {
    description: string = "";
    name: string = "";
    mobile: string = "";
    nation: string = "";
    gender: string = "";
    email: string = "";
    dateofbirth: string = "";
    main_patient: string = "";
    user_id: string = "";
    medical_report: File;
    radiology: File;
    retina: File;
    idPhoto: File;
}
